import { useState } from 'react';
import { history, useLocation } from 'umi';
import { Prompt } from 'react-router-dom';

interface IUseHandleQuoteBack {
  (): JSX.Element;
}

const useHandleQuoteBack: IUseHandleQuoteBack = () => {
  const [isPreventBack, setIsPreventBack] = useState<boolean>(true);
  const location = useLocation();

  const { from, pathname, query } = (location?.state || {}) as any;

  const promptElement = (
    <Prompt
      when={isPreventBack}
      message={(_, action) => {
        if (from === 'quote' && ['POP', 'REPLACE'].includes(action)) {
          setIsPreventBack(false);
          setTimeout(() => {
            history.replace({
              pathname,
              query,
              state: { from: 'product-list' },
            });
          }, 50);
          return false;
        }
        return true;
      }}
    />
  );

  return promptElement;
};

export default useHandleQuoteBack;
